import Vue from 'vue';

/**
 * Class Notification Service
 */
export default class NotificationService extends Vue { 

    private customActions = {
        setLastViewed: { method: 'PUT', url: 'auth/dashboard-notification/set-last-viewed' },
        newNotification: { method: 'POST', url: 'auth/dashboard-notification' },
        updateNotification: { method: 'PUT', url: 'auth/dashboard-notification' },
        deleteNotification: { method: 'DELETE', url: 'auth/dashboard-notification{/id}' },
        getNotifications: { method: 'GET', url: 'auth/dashboard-notification/' },
    };
    private resource: any = this.$resource('', {}, this.customActions);

    public getNotifications () {
        return this.resource.getNotifications({}).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public newNotification (params: any) {
        return this.resource.newNotification({}, params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public updateNotification (params: any) {
        return this.resource.updateNotification({}, params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public deleteNotification (id: number) {
        return this.resource.deleteNotification({id}).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public setLastViewed () {
        return this.resource.setLastViewed({}).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }
}
